import './Designs.css'

export default function Designs(){
    return(
        <section className="container designs">
            <div className="header">
                <h2 className="text-lg-white fw-light mb-4">Featured Designs</h2>
            </div>
            <div className="row designs-row">
                <div className="col-md-6 col-lg-4">
                    <div className="card my-md-2 border-0">
                    <div className="card-body p-0 bg-light">
                        <img className="img-fluid" src="https://m.hng.io/catalog/product/9/6/962752_ivory_4.jpg?io=PDP" alt=""/>
                    </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4">
                    <div className="card my-md-2 border-0">
                    <div className="card-body p-0 bg-light">
                        <img className="img-fluid" src="https://m.hng.io/catalog/product/9/6/960893_grey_2.jpg?io=PDP" alt=""/>
                    </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4">
                    <div className="card my-md-2 border-0">
                    <div className="card-body p-0 bg-light">
                        <img className="img-fluid" src="https://m.hng.io/catalog/product/9/6/960884_black_and_silver_2.jpg?io=PDP" alt=""/>
                    </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4">
                    <div className="card my-md-2 border-0">
                    <div className="card-body p-0 bg-light">
                        <img className="img-fluid" src="https://m.hng.io/catalog/product/9/5/958851_black_4.jpg?io=PDP" alt=""/>
                    </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4">
                    <div className="card my-md-2 border-0">
                    <div className="card-body p-0 bg-light">
                        <img className="img-fluid" src="https://m.hng.io/catalog/product/9/6/962367_black_2.jpg?io=PDP" alt=""/>
                    </div>
                    </div>
                </div>

                <div className="col-md-6 col-lg-4">
                    <div className="card my-md-2 border-0">
                    <div className="card-body p-0 bg-light">
                        <img className="img-fluid" src="https://m.hng.io/catalog/product/9/5/955835_black_4.jpg?io=PLP&dpr=1" alt=""/>
                    </div>
                    </div>
                </div>
            </div>
      </section>
    )
}